import { render, staticRenderFns } from "./saldotabungan.vue?vue&type=template&id=0395366b&scoped=true&"
import script from "./saldotabungan.vue?vue&type=script&lang=js&"
export * from "./saldotabungan.vue?vue&type=script&lang=js&"
import style0 from "./saldotabungan.vue?vue&type=style&index=0&id=0395366b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0395366b",
  null
  
)

export default component.exports